import type { CustomerSession } from "@shared-core/data/customer-api-types";
import { cn } from "../../app/components/primitives/utils";

// The portal's footer (trading companies D7): the legal details of the customer's current default trading company,
// as one line in the session. The portal words nothing and derives nothing: the backend words the line (the one
// wording every document and email uses, any missing part left out) and this prints it. The Pollards brand in the
// header is unchanged whichever company the line names. No details (the old organisation path, or a default naming
// no company) is no footer, never an empty one.

export function PortalFooter({
  legalDetails,
  className,
}: {
  legalDetails: CustomerSession["legal_details"] | undefined;
  /** The page's own width classes, so the footer lines up with the content above it. */
  className?: string;
}) {
  if (!legalDetails) return null;
  return (
    <footer
      className={cn(
        "mx-auto px-4 pb-8 text-xs text-muted-foreground sm:px-6",
        className,
      )}
    >
      <p className="border-t pt-4">{legalDetails.footer_line}</p>
    </footer>
  );
}
